export const initialFilters = {
    price_lte: 55000,
    price_per_point_lte: 305,
    points_on_contract_lte: 1600,
    points_on_contract_gte: 20
}

export const rangeMaxValues = {
    price: 50000,
    points_on_contract: 1500,
    price_per_point: 300
}
